module.exports = __webpack_public_path__ + "static/media/arrow-right.3fe79878.svg";